import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import useSWR from 'swr';

import {
    getSetting,
    saveSetting,
} from '../../services/identity/SettingService';
import {
    accountGlobalId,
    userGlobalId,
} from '../../store/selectors';

const settingUrl = `/api/identity/Setting`;

export const useGetSetting = (keys: string[], passUserId = false) => {
    const partitionGlobalId = useSelector(accountGlobalId);
    const accountId = useSelector(userGlobalId);

    return useSWR(
        {
            url: settingUrl,
            key: keys,
            partitionGlobalId,
            userId: passUserId ? accountId : undefined,
        },
        getSetting,
    );
};

export const useSetting = (keys: string[], passUserId = false) => {
    const accountId = useSelector(userGlobalId);
    const partitionGlobalId = useSelector(accountGlobalId);

    const {
        data, isLoading,
    } = useGetSetting(keys, passUserId);

    const updateSettings = useCallback(async (settings: Array<{ key: string; value: any }>) => {
        saveSetting(settingUrl, {
            settings,
            partitionGlobalId,
            userId: passUserId ? accountId : undefined,
        });
    }, [ partitionGlobalId, passUserId, accountId ]);

    return {
        settings: data,
        settingsLoading: isLoading,
        updateSettings,
    };
};
